import {Add} from '@mui/icons-material'
import {Box, Button} from '@mui/material'
import React from 'react'
import {UseFieldArrayAppend, UseFieldArrayRemove, UseFormReturn} from 'react-hook-form'

import {useTranslation} from '../../../hooks/useTranslation'
import {RoleAssignment} from '../../../modules/ManageUsers.selectors'
import {WidgetUserCreationFormData} from '../WidgetUserCreation.form'
import {useWidgetUserCreationStyles} from '../WidgetUserCreation.styles'
import {DataScopeOption} from '../WidgetUserCreation.types'

import {WidgetCustomerInput} from './WidgetCustomerInput'

interface WidgetUserCustomerIdsProps {
  formMethods: UseFormReturn<WidgetUserCreationFormData>
  fields: Array<{id: string; customerId: string; siteIds: string[]}>
  append: UseFieldArrayAppend<WidgetUserCreationFormData, 'customerIds'>
  remove: UseFieldArrayRemove
  selectedOrgUnit: DataScopeOption | undefined
  cscData: RoleAssignment[] | undefined
}

export const WidgetUserCustomerIds = ({
  formMethods,
  fields,
  append,
  remove,
  selectedOrgUnit,
  cscData
}: WidgetUserCustomerIdsProps) => {
  const {classes} = useWidgetUserCreationStyles()
  const {t} = useTranslation()

  return (
    <>
      <Box style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
        {fields.map((field, index) => (
          <Box key={field.id} style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
            <WidgetCustomerInput
              key={field.id}
              index={index}
              formMethods={formMethods}
              selectedOrgUnit={selectedOrgUnit}
              cscData={cscData}
              remove={remove}
            />
          </Box>
        ))}
      </Box>
      <Button
        startIcon={<Add style={{color: '#00374d', fontSize: '16px'}} />}
        className={classes.verifyButton}
        style={{alignSelf: 'start', marginTop: '12px'}}
        onClick={() => append({customerId: '', siteIds: []})}
      >
        {t('widgetUserCreation.form.addCustomerId')}
      </Button>
    </>
  )
}
